import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import CommonModal from 'jbc-front/components/CommonModal';
import Loading from 'src/components/Loading';

import styles from './CreateDeclarationLoadingModal.scss';

const CreateDeclarationLoadingModal = ({ isOpen, description }) => {
  const { t } = useTranslation();

  return (
    <CommonModal ariaHideApp={false} isOpen={isOpen} hideModal={() => {}} className={styles.createDeclarationLoadingModal}>
      <CommonModal.Header hideModal={() => {}}>{t('features.ReportIncomeTax.create.loading_title')}</CommonModal.Header>
      <CommonModal.Body className={styles.modalBody}>
        <div className={styles.body}>
          <Loading type="spin" />
          <p className={styles.description}>{description || t('features.ReportIncomeTax.create.loading_description')}</p>
        </div>
      </CommonModal.Body>
    </CommonModal>
  );
};

CreateDeclarationLoadingModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  description: PropTypes.string
};

CreateDeclarationLoadingModal.defaultProps = {
  description: ''
};

export default CreateDeclarationLoadingModal;
